// src/belediye/utils/dateLocal.js
// FAZ-47: YEREL tarih yardımcıları.
//
// NEDEN: `new Date().toISOString().slice(0,10)` tarihi UTC'ye çevirir. TR
// saatiyle 00:00–02:59 arasında bu DÜNÜN tarihini üretiyordu — "Bugün" çipiyle
// açılan görev doğar doğmaz "gecikmiş" görünüyordu. Tarih alanları (due_date)
// yerel takvim günüdür; hesabı yerel bileşenlerden yapıyoruz.
const pad = (n) => String(n).padStart(2, "0");

/** Date → "YYYY-MM-DD" (yerel takvim günü; UTC kayması YOK). */
export const isoLocalDate = (d = new Date()) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

/** Bugünden `days` gün sonrası → "YYYY-MM-DD". */
export const isoLocalInDays = (days = 0) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return isoLocalDate(d);
};

/** "HH:MM:SS" | "HH:MM" | null → input[type=time] değeri ("HH:MM" | ""). */
export const timeInputValue = (t) => (t ? String(t).slice(0, 5) : "");
